import { render, staticRenderFns } from "./course-tab-details.html?vue&type=template&id=c7336c20&scoped=true&"
import script from "./course-tab-details.js?vue&type=script&lang=js&"
export * from "./course-tab-details.js?vue&type=script&lang=js&"
import style0 from "./course-tab-details.css?vue&type=style&index=0&id=c7336c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7336c20",
  null
  
)

export default component.exports